export default {
  subTitle: {
    id: 'mobile_plan_drawer_sub_title',
    defaultMessage: 'Big things are happening',
  },
  title: {
    id: 'mobile_plan_drawer_title',
    defaultMessage: 'Mobile plans coming soon.',
  },
  description: {
    id: 'mobile_plan_drawer_description',
    defaultMessage:
      'Back Market is working to bring more value to your mobile plan. Get ready for monthly savings on premium coverage. Want to be the first to know when we launch? Add your email below to stay in the loop.',
  },
  privacyPolicy: {
    id: 'mobile_plan_drawer_privacy_policy',
    defaultMessage:
      'Your email will be collected by Back Market to contact you when the offer becomes available. It will be kept securely for up to six months and not shared with third parties. Learn more in our {privacyPolicy, html}.',
  },
  privacyPolicyLink: {
    id: 'mobile_plan_drawer_privacy_policy_link',
    defaultMessage: 'Privacy policy',
  },
  buttonLabel: {
    id: 'mobile_plan_drawer_button_label',
    defaultMessage: 'Join waitlist',
  },
  required: {
    id: 'mobile_plan_drawer_required',
    defaultMessage: 'This field is required',
  },
  invalidEmail: {
    id: 'mobile_plan_drawer_invalid_email',
    defaultMessage: 'This email is invalid',
  },
  emailLabel: {
    id: 'mobile_plan_drawer_email_label',
    defaultMessage: 'Email',
  },
  toastTitle: {
    id: 'mobile_plan_step_toast_title',
    defaultMessage: "You're in",
  },
  toastDescription: {
    id: 'mobile_plan_step_toast_description',
    defaultMessage: "We'll keep you in the loop for what's to come.",
  },
}
